// extracted by mini-css-extract-plugin
export var aircallIframe = "_eb-3";
export var fabContainer = "_eb-5";
export var fabRinging = "_eb-6";
export var loadingOverlay = "_eb-4";
export var pulse = "_eb-7";
export var widgetContent = "_eb-2";
export var widgetPanel = "_eb-0";
export var widgetPanelExpanded = "_eb-1";